export function initLpSurfaceSplit() {
    document.querySelectorAll('.js-lpSurfaceSplit').forEach((root) => {
        const nav = root.querySelector('.js-lpSurfaceSplitNav');
        const variantsWrap = root.querySelector('.js-lpSurfaceSplitVariants');
        const variants = Array.from(root.querySelectorAll('.js-lpSurfaceSplitVariant'));
        const images = Array.from(root.querySelectorAll('.js-lpSurfaceSplitImage'));
        const captionCategory = root.querySelector('.js-lpSurfaceSplitCaptionCategory');
        const captionTitle = root.querySelector('.js-lpSurfaceSplitCaptionTitle');
        if (!nav || !variantsWrap || !variants.length) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const imageByVariant = new Map();
        variants.forEach((btn, i) => imageByVariant.set(btn, images[i] || null));

        const categories = [];
        variants.forEach((btn) => {
            const cat = btn.dataset.category || '';
            if (!categories.includes(cat)) categories.push(cat);
        });

        const groups = new Map();
        variants.forEach((btn) => {
            const cat = btn.dataset.category || '';
            const grp = btn.dataset.group || '';
            const key = `${cat}\u0000${grp}`;
            let entry = groups.get(key);
            if (!entry) {
                const wrap = document.createElement('div');
                wrap.className = 'lpSurfaceSplit__group';
                if (grp) {
                    const label = document.createElement('span');
                    label.className = 'lpSurfaceSplit__groupLabel';
                    label.textContent = grp;
                    wrap.appendChild(label);
                }
                const items = document.createElement('div');
                items.className = 'lpSurfaceSplit__groupItems';
                wrap.appendChild(items);
                variantsWrap.appendChild(wrap);
                entry = { category: cat, wrap, items };
                groups.set(key, entry);
            }
            entry.items.appendChild(btn);
        });

        const navScroller = document.createElement('div');
        navScroller.className = 'lpSurfaceSplit__navScroller';
        nav.appendChild(navScroller);

        const indicator = document.createElement('span');
        indicator.className = 'lpSurfaceSplit__navIndicator';
        indicator.setAttribute('aria-hidden', 'true');
        navScroller.appendChild(indicator);

        const tabs = categories.map((cat) => {
            const tab = document.createElement('button');
            tab.type = 'button';
            tab.className = 'lpSurfaceSplit__navBtn';
            tab.setAttribute('role', 'tab');
            tab.textContent = cat;
            navScroller.appendChild(tab);
            return tab;
        });

        const moveIndicator = (tab) => {
            indicator.style.left = `${tab.offsetLeft}px`;
            indicator.style.width = `${tab.offsetWidth}px`;
        };

        const isHorizontalList = () => variantsWrap.scrollWidth > variantsWrap.clientWidth + 1
            && variantsWrap.scrollHeight <= variantsWrap.clientHeight + 1;

        const revealInScroller = (scroller, el, { center = false, smooth = true, axis = 'x' } = {}) => {
            const pad = 16;
            const horizontal = axis === 'x';
            const sRect = scroller.getBoundingClientRect();
            const eRect = el.getBoundingClientRect();
            const start = horizontal ? 'left' : 'top';
            const end = horizontal ? 'right' : 'bottom';
            const size = horizontal ? 'width' : 'height';
            const current = horizontal ? scroller.scrollLeft : scroller.scrollTop;
            const scrollPadEnd = parseFloat(getComputedStyle(scroller)[horizontal ? 'scrollPaddingRight' : 'scrollPaddingBottom']) || 0;
            const padEnd = Math.max(pad, scrollPadEnd);
            let target = null;
            if (center) {
                target = current + (eRect[start] - sRect[start]) - (sRect[size] - eRect[size]) / 2;
            } else if (eRect[start] < sRect[start] + pad) {
                target = current + (eRect[start] - sRect[start]) - pad;
            } else if (eRect[end] > sRect[end] - padEnd) {
                target = current + (eRect[end] - sRect[end]) + padEnd;
            }
            if (target === null) return;
            const instant = reduceMotion.matches || document.visibilityState === 'hidden';
            scroller.scrollTo({
                [horizontal ? 'left' : 'top']: Math.max(0, target),
                behavior: smooth && !instant ? 'smooth' : 'auto',
            });
        };

        const revealVariant = (btn, opts) => {
            revealInScroller(variantsWrap, btn, { ...opts, axis: isHorizontalList() ? 'x' : 'y' });
        };

        const selectedByCategory = new Map();

        const setVariant = (btn) => {
            variants.forEach((v) => {
                v.classList.toggle('is-active', v === btn);
                v.setAttribute('aria-pressed', v === btn ? 'true' : 'false');
            });
            selectedByCategory.set(btn.dataset.category || '', btn);
            const image = imageByVariant.get(btn);
            if (image && image.querySelector('picture, img')) {
                images.forEach((b) => b.classList.toggle('is-active', b === image));
            }
            const grp = btn.dataset.group || '';
            const title = btn.dataset.title || '';
            if (captionCategory) captionCategory.textContent = btn.dataset.category || '';
            if (captionTitle) captionTitle.textContent = [grp, title].filter(Boolean).join(' · ');
        };

        const setCategory = (cat, smooth = true) => {
            tabs.forEach((tab, i) => {
                const active = categories[i] === cat;
                tab.classList.toggle('is-active', active);
                tab.setAttribute('aria-selected', active ? 'true' : 'false');
                if (active) {
                    moveIndicator(tab);
                    revealInScroller(navScroller, tab, { center: true, smooth });
                }
            });
            groups.forEach((entry) => {
                entry.wrap.hidden = entry.category !== cat;
            });
            variantsWrap.scrollTo({ left: 0, top: 0, behavior: 'auto' });
            const next = selectedByCategory.get(cat)
                || variants.find((btn) => (btn.dataset.category || '') === cat);
            if (next) {
                setVariant(next);
                revealVariant(next, { smooth: false });
            }
        };

        tabs.forEach((tab, i) => {
            tab.addEventListener('click', () => setCategory(categories[i]));
        });
        variants.forEach((btn) => {
            btn.addEventListener('click', () => {
                setVariant(btn);
                revealVariant(btn);
            });
        });

        window.addEventListener('resize', () => {
            const active = tabs.find((tab) => tab.classList.contains('is-active'));
            if (active) {
                moveIndicator(active);
                revealInScroller(navScroller, active, { center: true, smooth: false });
            }
        });

        setCategory(categories[0], false);
    });
}
